define('inpageHeadline',[
  'jquery'
], function (
  $
) {
  var inpageHeadlineObj = inpageHeadlineObj || {

    init: function() {
      /* GET CURRENT LOCATION AND SET VALUES >>
      *
      * facebook title, description, and image handled in meta open graph tags
      * google+ title and image handled in meta open graph tags
      * current test url: http://projects.organic.com/fb_test/test.html
      *
      */

      var pageUrl = encodeURI(document.location);
      var pubId = 'ra-5342df2d3e0f72f8';
      var textTwitter = 'Take%20a%20look%20at%20this%20page%20on%20BuyaToyota.com';
      var relatedTwitter = 'toyota';
      var titleEmail = 'Take%20a%20look%20at%20this%20page%20on%20BuyaToyota.com';
      var fromEmail = 'noreply@toyota.com';
      var noteEmail = 'A%20page%20has%20been%20shared%20with%20you';

      if ($('.share-wraps').length > 0) {
        $('.ebrochure-link').insertBefore($('.share-wraps'));
      } else {
        $('.ebrochure-link').insertAfter($('#inpage-headline'));
        $('.ebrochure-link').css('margin-top','0px');
        $('.ebrochure-link').css('margin-right','0px');
      }

      /* ----- SHARE TOOLS ROLLOVERS ----- */

      $('.share-wraps').hover(function () {
        $('.inpage-share-tools-wrap').fadeIn(200);
      },
      function () {
        $('.inpage-share-tools-wrap').fadeOut(200);
      });


      /* ADA BAT-3846: EXPOSE SHARES ON KEYOARD TAB IN, EMULATE CLICK ON SPACE AND ENTER KEYS. */
      shareFocus = function (event) {
        var isMouse = $('.inpage-share-tools-wrap').hasClass('using-mouse');
        if (!isMouse) {
          $('.inpage-share-tools-wrap').fadeIn(200);
        }
      };
      socialFocusOut = function (event) { // onfocusout="socialFocusOut(event)"
        setTimeout(function () {
          var $activEl = $(document.activeElement);
          if (!$activEl.hasClass('icon-share-svg-img')) {
            $('.inpage-share-tools-wrap').fadeOut(200);
          }
        }, 1000);
      };

      // the share icons:
      socialShare = function (event) {
        if (event.keyCode === 9) { // allow tabbing.
          return;
        }
        // SPACE and ENTER
        if (event.keyCode === 32 || event.keyCode === 13) {
          var $ect = $(event.currentTarget);
          if ($ect.hasClass('facebook')) {
            $('.inpage-share-tools-wrap').find('.facebook').trigger('click');
          }
          if ($ect.hasClass('twitter')) {
            $('.inpage-share-tools-wrap').find('.twitter').trigger('click');
          }
          if ($ect.hasClass('plus')) {
            $('.inpage-share-tools-wrap').find('.plus').trigger('click');
          }
          $('.inpage-share-tools-wrap').hide();
          event.preventDefault();
          return;
        }
      };
      /* END BAT-3846 */
      /* ----- SHARE TOOLS CLICKS -----*/
      $('.inpage-share-tools-wrap').find('.facebook').click(function (e) {
        e.preventDefault();

        // handle addthis facebook (og meta tags handle title)
        window.open('http://api.addthis.com/oexchange/0.8/forward/facebook/offer' +
          '?url=' + pageUrl +
          '&pubid=' + pubId, '', 'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=400,height=350');
        $('.inpage-share-tools-wrap').hide();
      });

      $('.inpage-share-tools-wrap').find('.twitter').click(function (e) {
        e.preventDefault();
        // handle addthis twitter
        window.open('http://api.addthis.com/oexchange/0.8/forward/twitter/offer' +
          '?url=' + pageUrl +
          '&pubid=' + pubId +
          '&text=' + textTwitter +
          '&related=' + relatedTwitter, '', 'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=400,height=480');
        $('.inpage-share-tools-wrap').hide();
      });

      $('.inpage-share-tools-wrap').find('.plus').click(function (e) {
        e.preventDefault();
        // handle addthis google+
        window.open('http://api.addthis.com/oexchange/0.8/forward/google_plusone_share/offer' +
          '?url=' + pageUrl +
          '&pubid=' + pubId, '', 'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=450,height=640');
        $('.inpage-share-tools-wrap').hide();
      });

      $('.inpage-share-tools-wrap').find('.email').click(function (e) {
        e.preventDefault();

        // handle addthis email
        window.open('http://api.addthis.com/oexchange/0.8/forward/email/offer' +
          '?url=' + pageUrl +
          '&pubid=' + pubId +
          '&title=' + titleEmail +
          '&from=' + fromEmail +
          '&var_offers=' + encodeURI(window.location.origin + '/en/offers/') +
          '&var_vehicles=' + encodeURI(window.location.origin + '/en/vehicles/') +
          '&var_dealers=' + encodeURI(window.location.origin + '/en/dealers/') +
          '&note=' + noteEmail, '', 'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=480,height=600');
        $('.inpage-share-tools-wrap').hide();
      });
    }
  };
  return inpageHeadlineObj;
});

